import type { User } from '@/types';

export const resolvePrimaryCommunityId = (user: User | null | undefined): string | null => {
  if (!user) {
    return null;
  }

  const memberships = user.communityMemberships ?? [];
  const membershipIds = memberships
    .map((membership) => (typeof membership.communityId === 'string' ? membership.communityId.trim() : ''))
    .filter(Boolean);

  const defaultMembership = memberships.find((membership) => membership.isDefault === true);
  if (defaultMembership?.communityId) {
    return defaultMembership.communityId;
  }

  const scopedCommunityIds = Array.from(new Set((user.communityIds ?? []).map(id => (typeof id === 'string' ? id.trim() : '')).filter(Boolean)));

  if (scopedCommunityIds.length === 1) {
    return scopedCommunityIds[0];
  }

  if (membershipIds.length > 0) {
    return membershipIds[0];
  }

  return scopedCommunityIds[0] ?? null;
};


export const resolveAccessibleCommunityIds = (user: User | null | undefined): string[] => {
  if (!user) {
    return [];
  }

  const membershipIds = (user.communityMemberships ?? [])
    .map((membership) => (typeof membership.communityId === 'string' ? membership.communityId.trim() : ''))
    .filter(Boolean);

  const scopedCommunityIds = (user.communityIds ?? [])
    .map((id) => (typeof id === 'string' ? id.trim() : ''))
    .filter(Boolean);

  return Array.from(new Set([...scopedCommunityIds, ...membershipIds]));
};
